import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { Missile } from "../projectiles/missile";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class MissileGun extends Weapon {
	static key = "MissileGun";
	constructor(owner: Player) {
		super(owner, 10);
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.LAUNCHER;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_MISSILE));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		const missile = new Missile(spawnPos, direction);
		this.shotProjectile(board, missile);
	}

	static deserialize(data: any, owner: Player): MissileGun {
		const gun = new MissileGun(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
